import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const names = ['Martina', 'Juan', 'Sofía', 'Mateo', 'Valentina', 'Santiago', 'Camila', 'Nicolás', 'Lucía', 'Tomás', 'Florencia', 'Agustín', 'Micaela', 'Facundo', 'Julieta'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Tucumán', 'Bahía Blanca'];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: ''
  });
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 10000);
    // Interval for subsequent popups
    const intervalTimer = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, 25000); // Show every 25 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  return <AnimatePresence data-id="element-151">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      type: 'spring',
      bounce: 0.4
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-4" data-id="element-152">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-153">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-154" />
          </div>
          <div className="flex-1" data-id="element-155">
            <p className="text-sm font-medium text-gray-900" data-id="element-156">
              {currentBuyer.name} de {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-157">
              Acaba de comprar KIT Recruiter PRO™
            </p>
            <p className="text-xs text-blue-600 font-medium mt-1" data-id="element-158">
              Hace unos minutos
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-159">
            <X className="w-4 h-4" data-id="element-160" />
          </button>
        </motion.div>}
    </AnimatePresence>;
};